var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('horizontal-header')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }